import NavigationTabs from '@flatsy/core/Navigation/Tabs'
import React, { useState } from 'react'
import { generatePath, useHistory, useParams } from 'react-router'
import { BOOKING_NAVIGATION } from 'src/constants/Navigation'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import * as ROUTES from 'src/constants/Routes'
import { isPast } from 'date-fns'
import { parseApiDate } from '@flatsy/utils/Functions/DateTime/Date'
import { FrontApplicationState } from '@flatsy/types/Applications/Status'
import { useApplicationBooking } from 'src/hooks/ApplicationBooking'
import i18n from '@flatsy/utils/translations'
import Address from '../Address'
import Agent from '../Agent'
import DateStatus from '../DateStatus'
import UpdateBookingInformation from '../UpdateBookingInformation'
import Waiting from '../Waiting'
import { useStyles } from './Style'
import { renderApplicationInformation, renderCancelButton, renderIsImg } from './Utils'

const BookingOverviewMobile: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const [page, setPage] = useState(BOOKING_NAVIGATION.VISIT)
  const { applicationId } = useParams<{ applicationId: string }>()
  const { booking } = useApplicationBooking({ applicationId })
  const history = useHistory()
  const {
    asset,
    application: { application },
  } = useApplicationDetails()

  const handleCancel = async () => {
    history.push(
      generatePath(ROUTES.APPLICATION_DOSSIER_CANCEL, {
        applicationId,
      })
    )
  }

  const renderBookingDetails = () => {
    return application.computedState !== FrontApplicationState.WAITING_LIST ? (
      <>
        <div className={classes.containerApplication}>
          <DateStatus application={application} />
          <div className={classes.divider} />
          <Agent application={application} asset={asset} />
          <div className={classes.divider} />
          <Address application={application} />
        </div>

        <div className={classes.updateInformation}>
          <UpdateBookingInformation application={application} />
        </div>
        {booking && renderCancelButton(classes, handleCancel)}
      </>
    ) : (
      <>
        <Waiting asset={asset} />
        {booking && renderCancelButton(classes, handleCancel)}
      </>
    )
  }

  return (
    <div className={classes.container}>
      {renderIsImg(asset)}
      <div className={classes.width}>
        <NavigationTabs
          value={page}
          onChange={(_e, v) => setPage(v)}
          withContainer
          items={[
            {
              label: i18n.t('my_tour'),
              activeValue: BOOKING_NAVIGATION.VISIT,
            },
            {
              label: i18n.t('property_details'),
              activeValue: BOOKING_NAVIGATION.INFORMATION,
            },
          ]}
        />
      </div>
      {page === BOOKING_NAVIGATION.VISIT
        ? renderBookingDetails()
        : renderApplicationInformation(asset)}
    </div>
  )
}

export default BookingOverviewMobile
